import React from 'react'
import Footer from './components/Footer'
import { Outlet } from 'react-router-dom'
import Header from './components/Header/Header'
import { Analytics } from '@vercel/analytics/react'

function Layout() {
  return (
    <>
        <Header />
        <Outlet />
        <Footer />
        <Analytics />
    </>
  )
}

export default Layout